import React, { useEffect, useState } from 'react';
import { RootStateOrAny, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import lockIcon from '../../assets/lock.svg';
import logoutIcon from '../../assets/logout.svg';
import closeBtn from '../../assets/popup_close.svg';
import themeIcon from '../../assets/theme.svg';
import userSettingsIcon from '../../assets/user-settings.svg';
import '../../styles/components/options/sideMenu.scss';
import '../../styles/animations.scss';
import { signIn, signOutFromApp, updateCurrentPassword } from '../../auth/Auth';
import { CHANGE_PASSWORD_FORM } from '../../constants/FormNames';
import { checkHasErrors } from '../../constants/Validations';
import { ValidationTypes } from '../../enums/ValidationTypes';
import Button from '../Button';
import ColorBox from '../ColorBox';
import TextInput from '../TextInput';
import colorThemes from './colorThemes.json';
import DeleteUser from './popups/DeleteUser';

export default function SideMenu({ closeBtnHandler }) {
	const [height, setHeight] = useState('');
	const [visible, setVisible] = useState(false);
	const [colorTheme, setColorTheme] = useState(false);
	const [userSettings, setUserSettings] = useState(false);
	const form = useSelector(
		(state: RootStateOrAny) => state?.forms?.[CHANGE_PASSWORD_FORM]?.values
	);
	const user = useSelector((state: RootStateOrAny) => state?.user);
	const [loginError, setloginError] = useState('');
	const [deletePopup, setDeletePopup] = useState(false);
	const navigate = useHistory();

	const disabled = () => {
		return (
			checkHasErrors(CHANGE_PASSWORD_FORM, ['new_password', 'comfirm_password']) ||
			loginError !== ''
		);
	};

	useEffect(() => {
		const h = window.innerHeight;
		setHeight(`${h}px`);
	}, []);

	const handleSave = () => {
		if (form?.new_password === form?.comfirm_password) {
			signIn(
				user.userName,
				form?.current_password,
				() => {
					updateCurrentPassword(
						form?.new_password,
						() => {
							setloginError('New password saved');
						},
						error => {
							console.log(error);
							setloginError(error || '');
						}
					);
				},
				err => {
					console.log(err);
					setloginError(err || '');
				}
			);
		} else {
			setloginError('Passwords do not mached');
		}
	};

	const handleOutsideClick = e => {
		const classList = e.target.classList;
		if (classList.contains('side-menu-bg')) closeBtnHandler();
	};
	return (
		<div
			className='side-menu-bg'
			style={{ height: height }}
			onClick={e => handleOutsideClick(e)}
		>
			{deletePopup && <DeleteUser setDeletePopup={setDeletePopup} />}
			<div className='side-menu-wrapper slide-in-right'>
				<div className='close_popup'>
					<img src={closeBtn} alt='' onClick={closeBtnHandler} />
				</div>
				<div className='settings-content'>
					<div className='dropdown-toggle-switch'>
						<div
							className={colorTheme ? 'label active' : 'label'}
							onClick={() => setColorTheme(!colorTheme)}
						>
							<div className='caption'>
								<img src={themeIcon} />
								<span>Change theme color</span>
							</div>
							<i
								className={
									!colorTheme ? 'fa fa-chevron-down rotate ' : 'fa fa-chevron-up'
								}
								aria-hidden='true'
							></i>
						</div>

						<div className='color-themes-wrapper'>
							{colorTheme && (
								<div className='color-themes-container'>
									{colorTheme && colorThemes.map(theme => <ColorBox props={theme} />)}
								</div>
							)}
						</div>
					</div>
					<div className='dropdown-toggle-switch'>
						<div
							className={visible ? 'label active' : 'label'}
							onClick={() => setVisible(!visible)}
						>
							<div className='caption'>
								<img src={lockIcon} />
								<span>Change password</span>
							</div>
							<i
								className={!visible ? 'fa fa-chevron-down rotate ' : 'fa fa-chevron-up'}
								aria-hidden='true'
							></i>
						</div>

						{visible && (
							<div className='password-wrapper'>
								<div className='password'>
									<TextInput
										onFocus={() => setloginError('')}
										type='password'
										form={CHANGE_PASSWORD_FORM}
										id='current_password'
										placeholder='Current password'
										name={'current_password'}
										value={form?.current_password}
										validations={[ValidationTypes.required]}
									></TextInput>
								</div>
								<div className='password'>
									<TextInput
										onFocus={() => setloginError('')}
										type='password'
										form={CHANGE_PASSWORD_FORM}
										id='new_password'
										placeholder='New password'
										name={'new_password'}
										value={form?.new_password}
										validations={[ValidationTypes.password, ValidationTypes.required]}
									></TextInput>
								</div>
								<div className='password'>
									<TextInput
										onFocus={() => setloginError('')}
										type='password'
										form={CHANGE_PASSWORD_FORM}
										id='comfirm_password'
										placeholder='Confirm password'
										name={'comfirm_password'}
										value={form?.comfirm_password}
										validations={[ValidationTypes.password, ValidationTypes.required]}
									></TextInput>
								</div>
								<span
									className={
										loginError !== ''
											? 'form-error-message visible'
											: 'form-error-message'
									}
								>
									{loginError}
								</span>
								<div className='btn'>
									<Button
										active
										diactivated={disabled()}
										clicked={!loginError}
										onClickEvent={handleSave}
										className='span'
										id='save'
										labal='Save'
									></Button>
								</div>
							</div>
						)}
					</div>
					<div className='dropdown-toggle-switch'>
						<div
							className={userSettings ? 'label active' : 'label'}
							onClick={() => setUserSettings(!userSettings)}
						>
							<div className='caption'>
								<img src={userSettingsIcon} />
								<span>User settings</span>
							</div>
							<i
								className={
									!userSettings ? 'fa fa-chevron-down rotate ' : 'fa fa-chevron-up'
								}
								aria-hidden='true'
							></i>
						</div>
						{userSettings && (
							<div className='user-settings-wrapper'>
								<div className='sub-content'>
									<span className='caption'>Request for verification</span>
									<span className='description'>
										Verified accounts have a checkmark next to the username to show that
										Webbler has confirmed that they are the real presence public figures,
										celebrities and the brands they represent.
									</span>
									<div className='button-wrapper'>
										<Button
											labal={'Request for verification'}
											onClickEvent={() => console.log('verification request')}
										/>
									</div>
								</div>
								<div className='separator' />
								<div className='sub-content'>
									<span className='caption'>Delete your account</span>
									<span className='description'>
										Once deleted, all your information on Webbler will be cleared from our
										databases. There’s no going back. You may need to create a new account
										to use Webbler again.You may asked for the password to delete your
										account.
									</span>
									<div className='button-wrapper'>
										<Button
											labal={'Delete User'}
											onClickEvent={() => setDeletePopup(true)}
										></Button>
									</div>
								</div>
							</div>
						)}
					</div>
				</div>

				<div className='log-button'>
					<div className='logout'>
						<img src={logoutIcon} />
					</div>
					<span
						onClick={() => {
							signOutFromApp(() => {
								navigate.push('/login');
							});
						}}
					>
						Logout
					</span>
				</div>
			</div>
		</div>
	);
}
